import { ApiResponse, PaginatedResponse } from '@/domain'
import { ClientDetail, ClientFilters, ClientSummary, UpdateClientData } from '@/domain/clients/client'
import { CreateClientDto } from '@/domain/clients/client-schemas'
import { backendApi } from '../backendApi'

export const clientsApi = {
  createClient: (data: CreateClientDto) =>
    backendApi.post<ApiResponse<ClientSummary>>('/api/v1/data/clients', data).then((res) => res.data.data),

  getClients: (filters?: ClientFilters) =>
    backendApi.get<ApiResponse<PaginatedResponse<ClientSummary>>>('/api/v1/data/clients', { params: filters }).then((res) => res.data.data),

  getClient: (id: string) =>
    backendApi.get<ApiResponse<ClientDetail>>(`/api/v1/data/clients/${id}`).then((res) => res.data.data),

  updateClient: (id: string, data: UpdateClientData) =>
    backendApi.put<ApiResponse<ClientSummary>>(`/api/v1/data/clients/${id}`, data).then((res) => res.data.data),

  deleteClient: (id: string) =>
    backendApi.delete<ApiResponse<void>>(`/api/v1/data/clients/${id}`).then((res) => res.data.data),

  getClientBalance: (id: string) =>
    backendApi.get<ApiResponse<number>>(`/api/v1/data/clients/${id}/balance`).then((res) => res.data.data),

  getClientsStats: () =>
    backendApi.get<ApiResponse<{
      total: number
      active: number
      overdue: number
      blacklisted: number
      newThisMonth: number
    }>>('/api/v1/data/clients/stats').then((res) => res.data.data),

}
